firebird.controller('e2eeNotSupportedCtrl', [
    'meetingService',
    'helperService',
    'localizationService',
    'executionEnvironmentEnum',
    function (meetingService, helperService, localizationService, executionEnvironmentEnum) {
        var self = this;
        self.vdi = helperService.getVDIRef().getVdiType();
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.getHeader = getHeader;
        self.getMessage = getMessage;
        self.getImage = getImage;

        function getHeader() {
            return self.vdi === executionEnvironmentEnum.NonVDI
                ? localizationService.translate('LOBBY_PAGE.E2EE_IS_NOT_SUPPORTED_POPUP.HEADER')
                : localizationService.translate('LOBBY_PAGE.YOU_HAVE_BEEN_REMOVED_FROM_MEETING');
        }

        function getMessage() {
            return self.vdi === executionEnvironmentEnum.NonVDI
                ? localizationService.translate('LOBBY_PAGE.E2EE_IS_NOT_SUPPORTED_POPUP.MESSAGE')
                : localizationService.translate('LOBBY_PAGE.E2EE_IS_NOT_SUPPORTED_VDI.KICKED_MESSAGE', {
                      vdi: self.vdi
                  });
        }

        function getImage() {
            return self.vdi === executionEnvironmentEnum.NonVDI
                ? 'img/redesign/icons/warning-attention-exclamation.svg'
                : 'img/redesign/icons/door-exit-out.svg';
        }
    }
]);
